import { connect } from 'react-redux';
import { actions as telephonyActions } from 'components/settings/actions/telephony';
import { TopbarButtons, } from '../components/TopbarButtons';
const { telephonyGetNumbersByQuery } = telephonyActions;
const mapStateToProps = (state) => {
    return {
        telephonyState: state.settings.telephony,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getNumbersByQuery: (payload) => dispatch(telephonyGetNumbersByQuery(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TopbarButtons);
